import { useUIStore, useCalendarStore } from '../store';
import { Menu, Plus, ChevronLeft, ChevronRight, Calendar as CalendarIcon } from 'lucide-react';

interface HeaderProps {
  onMenuClick: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  const { currentView, openTaskModal, openProjectModal } = useUIStore();
  const { currentDate, goToToday, goToPrevious, goToNext } = useCalendarStore();

  const viewTitles: Record<string, string> = {
    list: '列表视图',
    week: '周视图',
    month: '月视图',
    mindmap: '思维导图',
    project: '项目视图',
    stats: '统计面板',
  };

  const formatDate = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;
    return `${year}年${month}月`;
  };

  const showNavigation = ['week', 'month'].includes(currentView);

  return (
    <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 md:px-6">
      {/* 左侧 */}
      <div className="flex items-center gap-4">
        <button
          onClick={onMenuClick}
          className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-all"
        >
          <Menu className="w-5 h-5" />
        </button>

        <h2 className="text-lg font-semibold text-gray-900">
          {viewTitles[currentView] || 'Life OS'}
        </h2>

        {/* 日期导航（周视图和月视图） */}
        {showNavigation && (
          <div className="hidden md:flex items-center gap-2 ml-4">
            <button
              onClick={goToPrevious}
              className="p-1.5 text-gray-600 hover:bg-gray-100 rounded-lg transition-all"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <span className="text-sm font-medium text-gray-700 min-w-[100px] text-center">
              {formatDate()}
            </span>
            <button
              onClick={goToNext}
              className="p-1.5 text-gray-600 hover:bg-gray-100 rounded-lg transition-all"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
            <button
              onClick={goToToday}
              className="ml-2 px-3 py-1 text-sm text-gray-600 hover:bg-gray-100 rounded-lg transition-all border border-gray-300"
            >
              今天
            </button>
          </div>
        )}
      </div>

      {/* 右侧 */}
      <div className="flex items-center gap-2">
        {/* 快速操作 */}
        <button
          onClick={() => openTaskModal()}
          className="hidden md:flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all"
        >
          <Plus className="w-4 h-4" />
          <span>新建任务</span>
        </button>

        <button
          onClick={() => openProjectModal()}
          className="hidden md:flex items-center gap-2 px-4 py-2 bg-white text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-all"
        >
          <Plus className="w-4 h-4" />
          <span>新建项目</span>
        </button>

        {/* 移动端快速操作 */}
        <button
          onClick={() => openTaskModal()}
          className="md:hidden p-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all"
        >
          <Plus className="w-5 h-5" />
        </button>
      </div>
    </header>
  );
}
